import { useMemo } from 'react'
import { ShowtimesVenue } from '../hooks/useVenueSearch/useVenueSearch'

const getVenuesSortedByDistance = (venues: ShowtimesVenue[]) => {
  return venues.sort((a, b) => {
    if (a.distance === undefined) return 1
    if (b.distance === undefined) return -1
    return a.distance - b.distance
  })
}

const useSortedVenues = ({ venues }: { venues: ShowtimesVenue[] }) => {
  const venuesWithShowtimes = useMemo(() => {
    const filtered = venues?.filter((venue) => venue?.showtimes.length > 0)
    return getVenuesSortedByDistance(filtered)
  }, [venues])

  const venuesWithNoShowtimes = useMemo(() => {
    const filtered = venues?.filter((venue) => venue?.showtimes.length === 0)
    return getVenuesSortedByDistance(filtered)
  }, [venues])

  return { venuesWithShowtimes, venuesWithNoShowtimes }
}

export default useSortedVenues
